import {
  AfterContentInit,
  Component,
  ContentChild,
  ElementRef,
  Input,
  OnInit,
} from '@angular/core';
import {
  ActivityVisibilityEnum,
  ReviewStatInterface,
} from '@sport-activities/sdk';

import { BadgeVariantEnum } from '~/component/badge/enums/variant.enum';
import { VtmnPlayButtonVariantEnum } from '~/component/buttons/vtmn-play-button/enum/vtmn-play-button-variant.enum';
import { VtmnPlayButtonShapeEnum } from '~/component/buttons/vtmn-play-button/enum/vtmn-play-button-shape.enum';
import { RatingSizeEnum } from '~/component/vtmn-rating/enums/RatingSize.enum';
import { toggle } from '~/core/helpers/animation/animation.helper';

import { ActivityCardVariantEnum } from './enum/variant.enum';
import { ActivityCardAttendeesInterface } from './interfaces/attendees.interface';
import { BookingTypeEnum } from '~/attendee/enums/booking-type.enum';
import { VtmnPlayIconTypeEnum } from '../vtmn-play-icon/enums/vtmn-play-icon-type.enum';
import { QrCodeService } from '~/organizer/shared/services/qr-code/qr-code.service';
import { QrCodeInterface } from '~/organizer/shared/services/qr-code/interfaces/qr-code-interface';
import isBulgaria from '~/core/helpers/country/country.helper';

@Component({
  selector: 'app-activity-card',
  templateUrl: './activity-card.component.html',
  styleUrls: ['./activity-card.component.scss'],
  animations: [toggle()],
})
export class ActivityCardComponent implements AfterContentInit, OnInit {
  @ContentChild('bottomText') public bottomText: ElementRef;
  @ContentChild('dropDown') public dropDown: ElementRef;
  @ContentChild('topText') public topText: ElementRef;

  @Input() public activityHasQrcode? = false;
  @Input() public printStyle = false;
  @Input() public address: string;
  @Input() public attendees: ActivityCardAttendeesInterface;
  @Input() public currency: string;
  @Input() public duration: string;
  @Input() public id: number;
  @Input() public isLive = false;
  @Input() public isOpened = false;
  @Input() public isStartingPrice = false;
  @Input() public maxPrice?: number;
  @Input() public picture: string;
  @Input() public price?: number;
  @Input() public reviewsStats?: ReviewStatInterface;
  @Input() public timeslotId?: string;
  @Input() public title: string;
  @Input() public type?: string;
  @Input() public variant = ActivityCardVariantEnum.DEFAULT;
  @Input() public visibility?: ActivityVisibilityEnum;

  public readonly badgeVariant = BadgeVariantEnum;
  public readonly ratingSizeEnum = RatingSizeEnum;
  public readonly vtmnPlayButtonShape = VtmnPlayButtonShapeEnum;
  public readonly vtmnPlayButtonVariant = VtmnPlayButtonVariantEnum;
  public readonly icon = VtmnPlayIconTypeEnum;

  public hasDropDown = false;
  public qrCodesScanned: number;

  constructor(private readonly qrCodeService: QrCodeService) {}

  public ngOnInit(): void {
    if (this.activityHasQrcode) {
      this.getQrCodesScanned(this.timeslotId);
    }
  }

  public ngAfterContentInit(): void {
    this.hasDropDown = Boolean(this.dropDown?.nativeElement?.children?.length);
  }

  public get expectedCustomers(): number {
    return this.attendees?.total || 0;
  }

  public get scansTotal(): number {
    return this.qrCodesScanned || 0;
  }

  public get isPrint(): boolean {
    return this.printStyle;
  }

  public get activityCardClass(): string {
    return (
      this.variant === ActivityCardVariantEnum.SHADOWLESS &&
      `activity-card--${ActivityCardVariantEnum.SHADOWLESS}`
    );
  }

  public get waitingValidation(): boolean {
    return this.type === BookingTypeEnum.WAITING;
  }

  public get hasBeenCanceled(): boolean {
    return this.type === BookingTypeEnum.CANCELED;
  }

  public get displayPrice(): boolean {
    return Number.isInteger(this.price) && this.price >= 0;
  }

  public get hasBottomText(): boolean {
    return Boolean(this.bottomText?.nativeElement);
  }

  public get hasTopText(): boolean {
    return Boolean(this.topText?.nativeElement);
  }

  public get isPrivate(): boolean {
    return this.visibility === ('PRIVATE' as ActivityVisibilityEnum);
  }

  public get toggleIcon(): string {
    return this.isOpened
      ? VtmnPlayIconTypeEnum.ArrowUp
      : VtmnPlayIconTypeEnum.ArrowDown;
  }

  public get isBg(): boolean {
    return isBulgaria();
  }

  public getQrCodesScanned(timeslotId): void {
    this.qrCodeService
      .getQrCodes(timeslotId)
      .subscribe((qrCodesData: QrCodeInterface[]) => {
        let count = 0;

        qrCodesData.forEach((qrCode) => {
          if (qrCode.scanCount > 0) {
            count += 1;
          }
        });

        this.qrCodesScanned = count;
      });
  }

  public toggle(): void {
    this.isOpened = !this.isOpened;
  }
}
